import { SakuraMark } from "@/components/SakuraMark";
import { scrollToId, waLink, WA_MESSAGES } from "@/lib/site";
import { MessageCircle } from "lucide-react";

const LINKS = [
    { id: "special", label: "This Month's Special" },
    { id: "products", label: "Products" },
    { id: "gallery", label: "Our Work" },
    { id: "how", label: "How to Order" },
    { id: "contact", label: "Contact" },
];

export const Navbar = () => (
    <header className="fixed inset-x-0 top-0 z-50 px-4 pt-4">
        <nav className="mx-auto flex max-w-7xl items-center justify-between gap-3 rounded-full border border-sakura-400/50 bg-white/70 py-2 pl-3 pr-2 shadow-[0_8px_30px_rgba(162,182,208,0.18)] backdrop-blur-xl">
            <button
                data-testid="nav-logo"
                onClick={() => scrollToId("top")}
                className="flex items-center gap-3"
                aria-label="Cherry Blossom Gifts — back to top"
            >
                <SakuraMark size={44} />
                <span className="font-display text-2xl md:text-[2.35rem] font-bold leading-[0.95] tracking-tight text-sakura-900 text-left">
                    Cherry Blossom
                    <span className="block pt-1 text-[15px] font-bold uppercase tracking-[0.26em] text-sakura-900">
                        Gifts
                    </span>
                </span>
            </button>

            <div className="hidden lg:flex items-center gap-6">
                {LINKS.map((l) => (
                    <button
                        key={l.id}
                        data-testid={`nav-link-${l.id}`}
                        onClick={() => scrollToId(l.id)}
                        className="text-sm font-medium text-sakura-800 hover:text-sky-600 transition-colors duration-200"
                    >
                        {l.label}
                    </button>
                ))}
            </div>

            <a
                data-testid="nav-whatsapp-btn"
                href={waLink(WA_MESSAGES.general)}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 rounded-full bg-sky-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-sky-700 transition-colors duration-200"
            >
                <MessageCircle size={16} strokeWidth={2.2} />
                <span className="hidden sm:inline">Order on WhatsApp</span>
                <span className="sm:hidden">Order</span>
            </a>
        </nav>
    </header>
);

export default Navbar;
